import React, { useState, useEffect } from "react";
import Immutiverse_logo from "../assets/icons/Immutaverse+Blue+White+Logo.webp";
import Hackable_Devices_Logo from "../assets/icons/Hackable_Devices_Logo.webp"
import AnimatedButton from "./AnimatedButton";
import useMediaQuery from "@mui/material/useMediaQuery";
import { AppBar,BackLink, BottomButtons, CloseIcon, DropdownContainer, DropdownItem, DropdownMenu, Hamburger, HeaderConatiner, HeaderLeft, ImmutiverseLogo, MenuContainer, MobileHeader, MobileLink, MobileMenu, NavigationLinks, RiskCalculator, StyledNavLink } from "../assets/styles/HeaderStyled";

/* ------------ Styled Components ------------ */


/* ------------ Component ------------ */
const HeaderContainer = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [solutionsOpen, setSolutionsOpen] = useState(false);
  const [activeLink, setActiveLink] = useState("risk-calculator");
  const [menuOpen, setMenuOpen] = useState(false);
  const [menuLevel, setMenuLevel] = useState("main");
  const isMobile = useMediaQuery("(max-width: 900px)");

  useEffect(() => {
    const currentPath = window.location.pathname;
    if (currentPath.includes("immutaverse-origin")) setActiveLink("origin");
    else if (currentPath.includes("immutaverse-radar")) setActiveLink("radar");
    else if (currentPath.includes("immutaverse-regen")) setActiveLink("regen");
    else if (currentPath.includes("new-product-introduction"))
      setActiveLink("npi");
    else if (currentPath.includes("device-security"))
      setActiveLink("device-security");
    else if (currentPath.includes("regulatory-compliance"))
      setActiveLink("regulatory");
    else setActiveLink("risk-calculator");
  }, []);

  const handleLink = (url) => {
    window.location.href = url;
    setMenuOpen(false);
  };

  return (
    <HeaderConatiner>
      <AppBar>
        <HeaderLeft>
          {/* <ImmutiverseLogo src={Immutiverse_logo} alt="Immutiverse Logo" /> */}
          <a href="https://hackabledevices.com/">
            <ImmutiverseLogo src={Hackable_Devices_Logo} 
             alt="Immutiverse Logo"
            //  width={350}
             height={80}
             loading="lazy"
             menuOpen={menuOpen} 
             />
          </a>

          {/* <NavigationLinks>
            {/* ---------- Platform Dropdown ---------- */}
            {/* <DropdownContainer
              onMouseEnter={() => setDropdownOpen(true)}
              onMouseLeave={() => setDropdownOpen(false)}
            >
              <StyledNavLink
                href="#platform"
                active={
                  activeLink === "origin" ||
                  activeLink === "radar" ||
                  activeLink === "regen"
                }
              >
                Platform
              </StyledNavLink>

              <DropdownMenu open={dropdownOpen}>
                <DropdownItem
                  href="https://www.immutaverse.com/immutaverse-origin"
                  onClick={() => setActiveLink("origin")}
                  active={activeLink === "origin"}
                >
                  Immutaverse Origin
                </DropdownItem>
                <DropdownItem
                  href="https://www.immutaverse.com/immutaverse-radar"
                  onClick={() => setActiveLink("radar")}
                  active={activeLink === "radar"}
                >
                  Immutaverse Radar
                </DropdownItem>
                <DropdownItem
                  href="https://www.immutaverse.com/immutaverse-regen"
                  onClick={() => setActiveLink("regen")}
                  active={activeLink === "regen"}
                >
                  Immutaverse Regen
                </DropdownItem>
              </DropdownMenu>
            </DropdownContainer> */}

            {/* ---------- Solutions Dropdown ---------- */}
            {/* <DropdownContainer
              onMouseEnter={() => setSolutionsOpen(true)}
              onMouseLeave={() => setSolutionsOpen(false)}
            >
              <StyledNavLink
                href="#solutions"
                active={
                  activeLink === "npi" ||
                  activeLink === "device-security" ||
                  activeLink === "regulatory"
                }
              >
                Solutions
              </StyledNavLink>

              <DropdownMenu open={solutionsOpen} style={{ minWidth: "280px" }}>
                <DropdownItem
                  href="https://www.immutaverse.com/new-product-introduction"
                  onClick={() => setActiveLink("npi")}
                  active={activeLink === "npi"}
                >
                  New Product Introduction
                </DropdownItem>
                <DropdownItem
                  href="https://www.immutaverse.com/device-security"
                  onClick={() => setActiveLink("device-security")}
                  active={activeLink === "device-security"}
                >
                  Scalable Device Security Workflows
                </DropdownItem>
                <DropdownItem
                  href="https://www.immutaverse.com/regulatory-compliance"
                  onClick={() => setActiveLink("regulatory")}
                  active={activeLink === "regulatory"}
                >
                  Regulatory Compliance
                </DropdownItem>
              </DropdownMenu>
            </DropdownContainer>

            <StyledNavLink
              href="https://www.immutaverse.com/about"
              active={activeLink === "about"}
              onClick={() => setActiveLink("about")}
            >
              About Immutaverse
            </StyledNavLink>
          </NavigationLinks> */}
        </HeaderLeft>

        {/* ---------- Right Side (Desktop Only) ---------- */}
        {/* {!isMobile && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "2.5rem",
              marginLeft: "auto",
            }}
          >
            <RiskCalculator
              active={activeLink === "risk-calculator"}
              onClick={() => setActiveLink("risk-calculator")}
            >
              Risk Calculator
            </RiskCalculator>

            <AnimatedButton text="Get a demo" />
          </div>
        )} */}

        {/* ---------- Hamburger (Mobile Only) ---------- */}
        {/* {isMobile && (
          <div style={{ marginLeft: "auto" }}>
            <Hamburger open={menuOpen} onClick={() => setMenuOpen(!menuOpen)}>
              <span />
              <span />
            </Hamburger>
          </div>
        )} */}
      </AppBar>

      {/* ---------- Mobile Menu ---------- */}

      {/* <MobileMenu open={menuOpen}>
        <MobileHeader>
          <CloseIcon onClick={() => setMenuOpen(false)}>×</CloseIcon>
        </MobileHeader>

        <div
          style={{
            position: "relative",
            width: "100%",
            height: "100%",
            overflow: "hidden",
          }}
        >
          {/* Main Menu */}
          {/* <MenuContainer level="main" menuLevel={menuLevel}>
            <MobileLink onClick={() => setMenuLevel("platform")}>
              Platform &gt;
            </MobileLink>
            <MobileLink onClick={() => setMenuLevel("solution")}>
              Solutions &gt;
            </MobileLink>
            <MobileLink
              onClick={() => handleLink("https://www.immutaverse.com/about")}
            >
              About Immutaverse
            </MobileLink>
            <MobileLink
              onClick={() =>
                handleLink("/")
              }
            >
              Risk Calculator
            </MobileLink>
          </MenuContainer> */}

          {/* Platform Submenu */}
          {/* <MenuContainer level="platform" menuLevel={menuLevel}>
            <BackLink onClick={() => setMenuLevel("main")}>&lt; Back</BackLink>
            <MobileLink
              onClick={() =>
                handleLink("https://www.immutaverse.com/immutaverse-origin")
              }
            >
              Immutaverse Origin
            </MobileLink>
            <MobileLink
              onClick={() =>
                handleLink("https://www.immutaverse.com/immutaverse-radar")
              }
            >
              Immutaverse Radar
            </MobileLink>
            <MobileLink
              onClick={() =>
                handleLink("https://www.immutaverse.com/immutaverse-regen")
              }
            >
              Immutaverse Regen
            </MobileLink>
          </MenuContainer> */}

          {/* Solutions Submenu */}
          {/* <MenuContainer level="solution" menuLevel={menuLevel}>
            <BackLink onClick={() => setMenuLevel("main")}>&lt; Back</BackLink>
            <MobileLink
              onClick={() =>
                handleLink(
                  "https://www.immutaverse.com/new-product-introduction"
                )
              }
            >
              New Product Introduction
            </MobileLink>
            <MobileLink
              onClick={() =>
                handleLink("https://www.immutaverse.com/device-security")
              }
            >
              Scalable Device Security Workflows
            </MobileLink>
            <MobileLink
              onClick={() =>
                handleLink("https://www.immutaverse.com/regulatory-compliance")
              }
            >
              Regulatory Compliance
            </MobileLink>
          </MenuContainer>
        </div>

        {menuLevel === "main" && (
          <BottomButtons>
            <div>
              <AnimatedButton text="Get a demo" />
            </div>
          </BottomButtons>
        )}
      </MobileMenu> */}
    </HeaderConatiner>
  );
};

export default HeaderContainer;
